import React from "react";

const portfolioSections = [
  {
    heading: "Reports & Long-Form Writing",
    items: [
      {
        title: "How AI Governance and Legal Oversight Are Driving Successful Adoption",
        type: "Report",
        description:
          "Legal teams and business leaders are building agile AI governance frameworks that balance innovation, oversight, trust and emerging risks such as agentic AI.",
        url: "https://library.iterable.com/3627/28703/901c1836bd7c4cdcbe37ca6e1d6d0dcd-trust-is-the-product-report.pdf?utm_source=Iterable&utm_medium=email&utm_campaign=campaign_17424763",
      },
      {
        title: "Building Resilience: The Future of Construction Disputes and ADR in an Ever-ChangingWorld",
        type: "Report",
        description:
          "How emerging risks — from climate and labor pressures to AI, financial uncertainty and global mega projects — are reshaping construction disputes and dispute resolution.",
        url: "https://library.iterable.com/3627/28703/9f698b5a74694c1aa4faf6184428d3d9-aaa_buildingresilience_thefutureofconstructiondisputesadrinever-changingworld.pdf?utm_source=Iterable&utm_medium=email&utm_campaign=campaign_18821599",
      },
      {
        title: "2025 AAA Annual Report",
        type: "Annual Report",
        description:
          "A year-in-review spotlighting major initiatives, milestones and strategic progress.",
        url: "https://www.adr.org/media/0sjesaxv/2025-aaa-annual-report.pdf",
      },
    ],
  },
  {
    heading: "Thought Leadership & Articles",
    items: [
      {
        title: "100 Years of Innovation Behind Us, 100 More Ahead",
        type: "Article",
        description:
          "Tracing how the AAA has shaped dispute resolution over 100 years, and where innovation is headed next.",
        url: "https://www.adr.org/news-and-insights/100-years-of-innovation/"
      },
      {
        title: "Nerding Out on Dispute Resolution: An Interview with ODR.com’s Colin Rule",
        type: "Interview",
        description:
          "A wide-ranging conversation on ODR trends, innovation and the future of dispute resolution.",
        url: "https://www.adr.org/news-and-insights/nerding-out-on-dispute-resolution-an-interview-with-odrcom-s-colin-rule/",
      },
      {
        title: "Jim Melamed: A Look at Technology’s Role in Mediation Through the Years",
        type: "Interview",
        description:
          "A reflective look at how technology has influenced mediation, and what’s changed over time.",
        url: "https://www.adr.org/news-and-insights/jim-melamed-a-look-at-technology-s-role-in-mediation-through-the-years/",
      },
    ],
  },
  {
    heading: "Outdoor & Adventure Journalism (Early Work)",
    items: [
      {
        title: "Two boys, two bikes, one adventure",
        type: "Feature",
        description:
          "A long-distance cycling journey told through immersive, place-based storytelling.",
        url: "https://www.fredericknewspost.com/archive/two-boys-two-bikes-one-adventure/article_5b71ff0b-24c4-57f0-a41b-24d7e83577b0.html",
      },
      {
        title: "Ridgerunners of the local Appalachian Trail",
        type: "Feature",
        description:
          "A reported feature spotlighting the people who maintain and protect the Appalachian Trail.",
        url: "https://www.fredericknewspost.com/archive/ridgerunners-of-the-local-appalachian-trail/article_d610f367-4b7a-521f-9910-7169414bbc97.html",
      },
      {
        title: "Man in the middle of nowhere",
        type: "Feature",
        description:
          "A human-interest portrait exploring isolation, resilience and life far off the beaten path.",
        url: "https://www.fredericknewspost.com/archive/man-in-the-middle-of-nowhere/article_876cd12c-5079-5144-b65a-55a0f7b1973f.html",
      },
      {
        title: "Into the depths: Student explores the underground",
        type: "Feature",
        description:
          "Following a student’s journey into underground cave systems and the science behind them.",
        url: "https://www.fredericknewspost.com/archive/into-the-depths-student-explores-the-underground/article_3af8d22d-79d6-54d6-88a4-7e3ba6e00d56.html",
      },
    ],
  },
];

const ctaLabel = (type) => {
  const t = (type || "").toLowerCase();
  if (t.includes("report")) return "View report";
  return "Read";
};

const Projects = () => {
  return (
    <div>
      <h3>Content Portfolio</h3>

      {portfolioSections.map((section) => (
        <div key={section.heading} className="my-4">
          <h4 className="mt-4">{section.heading}</h4>

          <div className="d-flex flex-row flex-wrap justify-content-center">
            {section.items.map((item) => (
              <div
                key={item.title}
                className="card mx-4 my-4 p-3"
                style={{ maxWidth: "400px" }}
              >
                <div className="card-body">
                  <p className="text-muted mb-2" style={{ fontSize: "0.85rem" }}>
                    {item.type}
                  </p>

                  <h5 className="card-title mb-2">{item.title}</h5>

                  <p className="card-text mb-3">{item.description}</p>

                  <a
                    href={item.url}
                    className="btn btn-outline-primary btn-sm project-button"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {ctaLabel(item.type)} →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Projects;



// import React from 'react';

// const Projects = () => {
//     return (
//       <div>
//         <h3>Projects</h3>
//         <div className='d-flex flex-row flex-wrap justify-content-center'>
//           <div className='card mx-4 my-4'>
//             <img src='../static/narrative-genius.webp' className='card-img-top' alt='...'></img>
//               <div className='card-body'>
//                 <h4 className='card-title'>NarrativeGenius</h4>
//                 <p className='card-text'>A creative writing AI chatbot.</p>
//                 <a href='https://narrative-genius.pages.dev/' className='btn btn-primary btn-sm project-button mx-2'>Visit site</a>
//                 <a href='https://github.com/kendalenz/narrative-genius' className='btn btn-primary btn-sm project-button mx-2'>View code</a>
//               </div>
//           </div>
//           <div className='card mx-4 my-4'>
//             <img src='../static/elysium.webp' className='card-img-top' alt='...'></img>
//               <div className='card-body'>
//                 <h4 className='card-title'>Elysium</h4>
//                 <p className='card-text'>An e-commerce site.</p>
//                 <a href='https://earthen-foods.onrender.com/' className='btn btn-primary btn-sm project-button mx-2'>Visit site</a>
//                 <a href='https://github.com/kendalenz/elysium' className='btn btn-primary btn-sm project-button mx-2'>View code</a>
//               </div>
//           </div>
//           <div className='card mx-4 my-4'>
//             <img src='../static/evo-gym.webp' className='card-img-top' alt='...'></img>
//               <div className='card-body'>
//                 <h4 className='card-title'>EvoGym</h4>
//                 <p className='card-text'>A fitness web app.</p>
//                 <a href='https://fitness-app-ewf.pages.dev/' className='btn btn-primary btn-sm project-button mx-2'>Visit site</a>
//                 <a href='https://github.com/kendalenz/fitness-app' className='btn btn-primary btn-sm project-button mx-2'>View code</a>
//               </div>
//           </div>
//            <div className='card mx-4 my-4'>
//             <img src='../static/gabriel-zapata.webp' className='card-img-top mb-2' alt='...'></img>
//             <div className='card-body'>
//               <h4 className='card-title mt-4'>Gabriel Zapata</h4>
//               <p className='card-text'>A personl portfolio website.</p>
//               <a href='https://www.gabriel-zapata.com/' className='btn btn-primary btn-sm project-button mx-2'>Visit site</a>
//               <a href='https://github.com/kendalenz/gabriel-zapata' className='btn btn-primary btn-sm project-button mx-2'>View code</a>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
// };

// export default Projects;